import { SearchProvider } from '@cast/shared-search-ui';
import { useCluster } from '@cast/shared-cluster-context-data-access';
import { WorkloadCostSummariesItem } from '@cast/types';
import { Box } from '@cast/design-system';
import {
  ComputeCostCostReportProvider,
  ComputeCostWorkloadsSection,
  useComputeCostWorkloads,
  useWorkloadsSearchCriteria,
  WorkloadFilters,
} from '@cast/split-me/features/cluster/cost-report';

import { WORKLOAD_CATEGORIES, WORKLOAD_VIEWS } from '../../../_constants';
import { inventoryWorkloadsTableKeys, tableCacheKeys } from '../../../consts';
import { buildInventoryWorkloadViewPath } from '../../../navigation';

const ComputeContent = () => {
  const criteria = useWorkloadsSearchCriteria();
  const { cluster } = useCluster();

  const getWorkloadLink = (workload: WorkloadCostSummariesItem) =>
    buildInventoryWorkloadViewPath({
      clusterId: cluster.id,
      workloadId: workload.id,
      category: WORKLOAD_CATEGORIES.COMPUTE,
      view: WORKLOAD_VIEWS.DASHBOARD,
    });

  return (
    <SearchProvider
      criteria={criteria}
      useData={useComputeCostWorkloads}
      urlKey={inventoryWorkloadsTableKeys.COMPUTE}
      serverSideSort
      disableFreeText
    >
      <Box mb={15}>
        <WorkloadFilters size="small" />
      </Box>
      <ComputeCostWorkloadsSection
        cacheKey={tableCacheKeys.INVENTORY_WORKLOADS.COMPUTE}
        getWorkloadLink={getWorkloadLink}
      />
    </SearchProvider>
  );
};

export const InventoryWorkloadsListCompute = () => (
  <ComputeCostCostReportProvider>
    <ComputeContent />
  </ComputeCostCostReportProvider>
);
